import { useEffect, useState } from "react";

const links = [
  ["Samples", "#samples"],
  ["Occasions", "#occasions"],
  ["How It Works", "#how-it-works"],
  ["Reviews", "#reviews"],
  ["FAQ", "#faq"],
];

const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export default function Navbar({ content, onOrder }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const price = content?.price ?? 2999;
  const original = content?.original_price ?? 5999;
  const brand = content?.brand_name ?? "Vowyo";

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 border-b-[3px] border-ink transition-all duration-300 ${scrolled ? "bg-cream/95 backdrop-blur-md" : "bg-cream"}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center" data-testid="nav-brand-link">
          <img src="/logo.png" alt={brand} data-testid="brand-logo" className="h-8 sm:h-9 w-auto transition-transform duration-300 hover:scale-105" />
        </a>
        {(content?.nav_links_visible !== false) && (
        <nav className="hidden lg:flex items-center gap-7" data-testid="nav-links">
          {links.map(([label, href]) => (
            <a key={href} href={href} data-testid={`nav-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-head font-semibold text-sm text-plum hover:text-pink transition-colors duration-200">
              {label}
            </a>
          ))}
        </nav>
        )}
        <div className="flex items-center gap-3">
          <div className="hidden sm:flex items-center gap-2 rounded-full bg-sunny border-2 border-ink px-3.5 py-1.5 shadow-[3px_3px_0_#2D1A32] rotate-[-2deg]" data-testid="nav-price-pill">
            <span className="font-mono text-[11px] line-through opacity-60">{inr(original)}</span>
            <span className="font-display font-semibold text-sm">{inr(price)}</span>
          </div>
          <button
            data-testid="nav-gift-song-btn"
            onClick={onOrder}
            className="btn-pop rounded-full bg-pink text-white font-head font-bold text-sm px-5 py-2.5 border-2 border-ink shadow-[4px_4px_0_#2D1A32]"
          >
            Gift a Song
          </button>
        </div>
      </div>
    </header>
  );
}
